import { GAME_ACTION_TO_BEGINNER_HINT_TYPE } from '../../core/UIGameBeginnerHint/utils.ts';
export const createGameBeginnerHintSlice = ()=>(set, get)=>({
            gameBeginnerHint: {
                beginnerHintType: undefined,
                setBeginnerHintType: (beginnerHintType)=>set({
                        gameBeginnerHint: {
                            ...get().gameBeginnerHint,
                            beginnerHintType: beginnerHintType
                        }
                    }),
                beginnerHintData: undefined,
                setBeginnerHintData: (beginnerHintData)=>{
                    const beginnerHintType = beginnerHintData ? GAME_ACTION_TO_BEGINNER_HINT_TYPE[beginnerHintData.type] : null;
                    if (beginnerHintType != null) {
                        set({
                            gameBeginnerHint: {
                                ...get().gameBeginnerHint,
                                beginnerHintType: beginnerHintType
                            }
                        });
                    }
                    set({
                        gameBeginnerHint: {
                            ...get().gameBeginnerHint,
                            beginnerHintData: beginnerHintData
                        }
                    });
                },
                beginnerActionState: undefined,
                setBeginnerActionState: (actionState)=>set({
                        gameBeginnerHint: {
                            ...get().gameBeginnerHint,
                            beginnerActionState: actionState
                        }
                    })
            }
        });
